const baseViewFactory = require('./view');
module.exports = baseViewFactory({
    iframeLightbox: null,
    renderIframe() {
        this.renderIframeTemplate();
        const $iframe = this.$cachedSelectors.userInteractionLayer.find(`#${this.userInteractionIframeId}`);
        let iframeOptions = {};

        if (this.isCheckIn()) {
            this.toggleInteractionLayer(true);
            this.createIframeLightbox();
            this.iframeLightbox.toggle(true);
            iframeOptions = {customFeedback: true, genericError: true};
        } else {
            this.togglePaymentForm({
                show: false,
            });
            this.toggleInteractionLayer(true);
        }
        window.addEventListener('message', Odigeo._.partial(this.messageReceivedFromIframe, _, $iframe, iframeOptions).bind(this), false);
        Odigeo.trigger(`${this.id}:onCheckoutInteractionNeeded`);
    },
    createIframeLightbox() {
        this.iframeLightbox = new Odigeo.UIElements.Lightbox(this.$cachedSelectors.userInteractionLayer.find('.user_interaction_wrapper'),
            {
                overFullPage: false,
                blockScroll: false,
                closeOnOuterClick: false,
                closeOnNavigate: false,
                closingClass: '.checkinF_iframe_close',
                onClose: () => {
                    Odigeo.trigger(`${this.id}:onCheckoutInteractionNeededClosed`);
                    this.managePaymentRetry({customFeedback: true});
                },
            });
    },
    closeIframeContainer() {
        this.iframeLightbox.toggle(false);
        Odigeo.trigger(`${this.id}:onCheckoutInteractionNeededClosed`);
    },
});
